import * as yup from 'yup'

const SCHEMA_ITEM = yup.object({
  dsItemSeguranca: yup.string().typeError('Campo obrigatório.').required('Campo obrigatório.'),
  nmItemSeguranca: yup.string().typeError('Campo obrigatório.').required('Campo obrigatório.'),
  txLegislacaoItemSeguranca: yup.string().typeError('Campo obrigatório.').required('Campo obrigatório.')
})

const SCHEMA_SUBITEM = yup.object({
  dsSubItem: yup.string().typeError('Campo obrigatório.').required('Campo obrigatório.'),
  idInfracao: yup.number().typeError('Campo obrigatório.').required('Campo obrigatório.'),
  nmSubItem: yup.string().typeError('Campo obrigatório.').required('Campo obrigatório.')
})

export {
  SCHEMA_ITEM,
  SCHEMA_SUBITEM
}